import { createFileRoute } from '@tanstack/react-router';
import Wrapper from '../../../../components/Wrapper';
import { Alert, Button, Input } from 'antd';
import useShopAttrs from '../../../../utils/hooks/useShopAttrs';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { useState } from 'react';
import CModal from '../../../../components/CModal';
import { IconKey } from '@tabler/icons-react';
import { useMutation } from '@tanstack/react-query';
import { apiV1 } from '../../../../utils/apiClient';
import CopyText from '../../../../microcomponents/CopyText';

export const Route = createFileRoute('/_authenticated/settings/api-keys')({
  component: RouteComponent
});

function RouteComponent() {

  const flagEnabled = useFeatureFlagEnabled('open-api-alpha');
  const [apiKey, setApiKey] = useState<undefined | string>(undefined);

  const generateNewApiKey = useMutation({
    mutationFn: async () => {
      return await apiV1.post<string>('/shop/open-api/api-key', {});
    },
    onSuccess: (data) => setApiKey(data)
  });


  return (
    <div>
      {!flagEnabled
        &&
        <Alert
          description={'L\'Api di Next is Free è in fase di Alpha ed è disponibile solo per alcuni utenti. Puoi richiedere l\'accesso scrivendo a sales@nextisfree.io'}>
        </Alert>
      }
      <Wrapper
        subtitle={'Genera una chiave privata per autenticare le richieste all\'api. Assicurati di mantenerla segreta.'}
        disabled={!flagEnabled} mt={20} title={'Api Key'}>
        <div className={'flex gap-2'}>
          <Input disabled placeholder={'Api key'} value={'······························'} />
          <Button onClick={() => generateNewApiKey.mutate()} loading={generateNewApiKey.isPending} type={'primary'}
                  disabled={!flagEnabled}>Ottieni Nuova</Button>
        </div>
      </Wrapper>
      <CModal width={440} title={'Nuova Api Key'} confirmButtonText={'ok'} hideConfirmButton cancelButtonText={'Chiudi'}
              open={!!apiKey} onClose={() => setApiKey(undefined)} icon={<IconKey />} color={'blue'}
              mutationOptions={{}}>
        <div>
          <CopyText text={apiKey || '' } label={'Api Key'}/>
        </div>
      </CModal>
    </div>
  );
}
